import React, {FC, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'

import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import {ToastContainer} from 'react-toastify'

import {AddCarRentalHeader} from './AddCarRentalHeader'
import {Tr} from '../../../_metronic/i18n/Tr'

const AddCarRentalDocuments: FC = () => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()

  const location = useLocation()
  const editCarrentalId = (location.state as any)?.carrentalId || ''
  const [carRentalDetails, setCarRentalDetails] = useState([])

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const primaryLanguage = sessionStorage.getItem('primaryLanguage')
  const [showCustomDocs, setShowCustomDocs] = useState(false)
  const [passportEN, setPassportEN] = useState('')
  const [passportRU, setPassportRU] = useState('')
  const [passportUZ, setPassportUZ] = useState('')
  const [drivingLicenseEN, setDrivingLicenseEN] = useState('')
  const [drivingLicenseRU, setDrivingLicenseRU] = useState('')
  const [drivingLicenseUZ, setDrivingLicenseUZ] = useState('')
  const [creditCardInfoEN, setCreditCardInfoEN] = useState('')
  const [creditCardInfoRU, setCreditCardInfoRU] = useState('')
  const [creditCardInfoUZ, setCreditCardInfoUZ] = useState('')

  const toggleCustomDocs = () => {
    setShowCustomDocs(!showCustomDocs)
  }
  const initialField = {
    en_title: '',
    en_description: '',
    ru_title: '',
    ru_description: '',
    uz_title: '',
    uz_description: '',
  }

  const [customDocs, setCustomDocs] = useState([initialField])
  const [errors, setErrors] = useState([]) as any

  const handleAddField = () => {
    setCustomDocs([...customDocs, initialField])
    setErrors([...errors, {}]) // Ensure a new error object is added for the new field
  }

  const handleRemoveField = (index: any) => {
    if (index !== 0) {
      // Prevent removal of the first field
      const newCustomDocs = customDocs.filter((_, i) => i !== index)
      const newErrors = errors.filter((_: any, i: any) => i !== index)
      setCustomDocs(newCustomDocs)
      setErrors(newErrors)
    }
  }

  const handleChange = (index: any, field: any, value: any) => {
    const newCustomDocs = customDocs.map((f, i) => (i === index ? {...f, [field]: value} : f))
    setCustomDocs(newCustomDocs)

    const newErrors = errors.map((err: any, i: any) => (i === index ? {...err, [field]: ''} : err))
    setErrors(newErrors)
  }
  // set error state
  const [error, setError] = useState([
    {
      passportEN: '',
      passportRU: '',
      passportUZ: '',
      drivingLicenseEN: '',
      drivingLicenseRU: '',
      drivingLicenseUZ: '',
      creditCardInfoEN: '',
      creditCardInfoRU: '',
      creditCardInfoUZ: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (passportEN.trim() == '' || passportEN.trim() == null || passportEN.trim() == undefined) {
        errorTmp[0].passportEN = t('Description Is Required')
        isValid = false
      }
      if (
        drivingLicenseEN.trim() == '' ||
        drivingLicenseEN.trim() == null ||
        drivingLicenseEN.trim() == undefined
      ) {
        errorTmp[0].drivingLicenseEN = t('Description Is Required')
        isValid = false
      }
      if (
        creditCardInfoEN.trim() == '' ||
        creditCardInfoEN.trim() == null ||
        creditCardInfoEN.trim() == undefined
      ) {
        errorTmp[0].creditCardInfoEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (passportRU.trim() == '' || passportRU.trim() == null || passportRU.trim() == undefined) {
        errorTmp[0].passportRU = t('Description Is Required')
        isValid = false
      }
      if (
        drivingLicenseRU.trim() == '' ||
        drivingLicenseRU.trim() == null ||
        drivingLicenseRU.trim() == undefined
      ) {
        errorTmp[0].drivingLicenseRU = t('Description Is Required')
        isValid = false
      }
      if (
        creditCardInfoRU.trim() == '' ||
        creditCardInfoRU.trim() == null ||
        creditCardInfoRU.trim() == undefined
      ) {
        errorTmp[0].creditCardInfoRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (passportUZ.trim() == '' || passportUZ.trim() == null || passportUZ.trim() == undefined) {
        errorTmp[0].passportUZ = t('Description Is Required')
        isValid = false
      }
      if (
        drivingLicenseUZ.trim() == '' ||
        drivingLicenseUZ.trim() == null ||
        drivingLicenseUZ.trim() == undefined
      ) {
        errorTmp[0].drivingLicenseUZ = t('Description Is Required')
        isValid = false
      }
      if (
        creditCardInfoUZ.trim() == '' ||
        creditCardInfoUZ.trim() == null ||
        creditCardInfoUZ.trim() == undefined
      ) {
        errorTmp[0].creditCardInfoUZ = t('Description Is Required')
        isValid = false
      }
    }

    if (showCustomDocs) {
      const newErrors = [] as any
      customDocs.forEach((field, index) => {
        newErrors[index] = {}

        if (primaryLanguage === 'English') {
          if (!field.en_title || !field.en_title.trim()) {
            newErrors[index].en_title = t('Document Title Is Required')
            isValid = false
          }
          if (!field.en_description || !field.en_description.trim()) {
            newErrors[index].en_description = t('Document Description Is Required')
            isValid = false
          }
        } else if (primaryLanguage === 'Russian') {
          if (!field.ru_title || !field.ru_title.trim()) {
            newErrors[index].ru_title = t('Document Title Is Required')
            isValid = false
          }
          if (!field.ru_description || !field.ru_description.trim()) {
            newErrors[index].ru_description = t('Document Description Is Required')
            isValid = false
          }
        } else if (primaryLanguage === 'Uzbek') {
          if (!field.uz_title || !field.uz_title.trim()) {
            newErrors[index].uz_title = t('Document Title Is Required')
            isValid = false
          }
          if (!field.uz_description || !field.uz_description.trim()) {
            newErrors[index].uz_description = t('Document Description Is Required')
            isValid = false
          }
        }
      })

      setErrors(newErrors)
    }

    setError(errorTmp)
    return isValid
  }

  // add business details api call
  const addDocumentRequiredApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      var param: any = {
        carrentalId: String(editCarrentalId),
        en_passport: passportEN,
        ru_passport: passportRU,
        uz_passport: passportUZ,
        en_drivingLincense: drivingLicenseEN,
        ru_drivingLincense: drivingLicenseRU,
        uz_drivingLincense: drivingLicenseUZ,
        en_creditCardinfo: creditCardInfoEN,
        ru_creditCardinfo: creditCardInfoRU,
        uz_creditCardinfo: creditCardInfoUZ,
      }
      if (showCustomDocs) {
        param['customeDocument'] = customDocs
      }

      var res = await fetchData('vendor/public/adddocumentrequired', param)
      if (res.status == '200') {
        toastsuccessmsg('Required Documents Info Added Successfully!')
        const state = {
          carrentalId: editCarrentalId,
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addcarrentalavailability/', {menuId:menuId}), {state})  
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }
  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData('vendor/public/carRentalDetail', param)
    if (response.status == '200') {
      setCarRentalDetails(response.data)
      var data = response.data[0]

      setPassportEN(data.en_passport)
      setPassportRU(data.ru_passport)
      setPassportUZ(data.uz_passport)
      setDrivingLicenseEN(data.en_drivingLincense)
      setDrivingLicenseRU(data.ru_drivingLincense)
      setDrivingLicenseUZ(data.uz_drivingLincense)
      setCreditCardInfoEN(data.en_creditCardinfo)
      setCreditCardInfoRU(data.ru_creditCardinfo)
      setCreditCardInfoUZ(data.uz_creditCardinfo)
      if (data.customeDocument.length != 0) {
        setShowCustomDocs(true)
        setCustomDocs(data.customeDocument)
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editCarrentalId != '') {
      carRentalDetailsApiCall()
    }
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editCarrentalId != '' ? t('Edit Documents Required') : t('Add Documents Required')}
      </PageTitle>
      <AddCarRentalHeader carrentalId={editCarrentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Documents Required')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {carRentalDetails.length != 0 ? (
                            <>
                              {carRentalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['carRentalInfo']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['insurance']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['documentsRequired']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        {primaryLanguage == 'English' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('ID/Passport (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportEN'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportEN(e.target.value)
                                    removeError('passportEN')
                                  }}
                                  value={passportEN}
                                ></textarea>
                                <div className='text-danger fw-bold'>{error[0].passportEN}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('ID/Passport (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportRU'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportRU(e.target.value)
                                  }}
                                  value={passportRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('ID/Passport (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportUZ(e.target.value)
                                  }}
                                  value={passportUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Driving License (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseEN'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseEN(e.target.value)
                                    removeError('drivingLicenseEN')
                                  }}
                                  value={drivingLicenseEN}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].drivingLicenseEN}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseRU'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseRU(e.target.value)
                                  }}
                                  value={drivingLicenseRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseUZ(e.target.value)
                                  }}
                                  value={drivingLicenseUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Payment Card Details (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoEN'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoEN(e.target.value)
                                    removeError('creditCardInfoEN')
                                  }}
                                  value={creditCardInfoEN}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].creditCardInfoEN}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Payment Card Details (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoRU'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoRU(e.target.value)
                                  }}
                                  value={creditCardInfoRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Payment Card Details (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoUZ(e.target.value)
                                  }}
                                  value={creditCardInfoUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Passport (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportRU'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportRU(e.target.value)
                                    removeError('passportRU')
                                  }}
                                  value={passportRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].passportRU}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Passport (English)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportEN'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportEN(e.target.value)
                                  }}
                                  value={passportEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Passport (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportUZ(e.target.value)
                                  }}
                                  value={passportUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Driving License (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseRU'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseRU(e.target.value)
                                    removeError('drivingLicenseRU')
                                  }}
                                  value={drivingLicenseRU}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].drivingLicenseRU}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseEN'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseEN(e.target.value)
                                  }}
                                  value={drivingLicenseEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseUZ(e.target.value)
                                  }}
                                  value={drivingLicenseUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Credit Card Info (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoRU'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoRU(e.target.value)
                                    removeError('creditCardInfoRU')
                                  }}
                                  value={creditCardInfoRU}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].creditCardInfoRU}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Credit Card Info (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoEN'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoEN(e.target.value)
                                  }}
                                  value={creditCardInfoEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Credit Card Info (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoUZ(e.target.value)
                                  }}
                                  value={creditCardInfoUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Passport (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportUZ(e.target.value)
                                    removeError('passportUZ')
                                  }}
                                  value={passportUZ}
                                ></textarea>
                                <div className='text-danger fw-bold'>{error[0].passportUZ}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Passport (Russian)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportRU'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportRU(e.target.value)
                                  }}
                                  value={passportRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Passport (English)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='passportEN'
                                  className='form-control mb-2'
                                  placeholder={t('Passport Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPassportEN(e.target.value)
                                  }}
                                  value={passportEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Driving License (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseUZ(e.target.value)
                                    removeError('drivingLicenseUZ')
                                  }}
                                  value={drivingLicenseUZ}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].drivingLicenseUZ}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseRU'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseRU(e.target.value)
                                  }}
                                  value={drivingLicenseRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Driving License (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='drivingLicenseEN'
                                  className='form-control mb-2'
                                  placeholder={t('Driving License Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDrivingLicenseEN(e.target.value)
                                  }}
                                  value={drivingLicenseEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Credit Card Info (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoUZ(e.target.value)
                                    removeError('creditCardInfoUZ')
                                  }}
                                  value={creditCardInfoUZ}
                                ></textarea>
                                <div className='text-danger fw-bold'>
                                  {error[0].creditCardInfoUZ}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Credit Card Info (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoRU'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoRU(e.target.value)
                                  }}
                                  value={creditCardInfoRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Credit Card Info (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='creditCardInfoEN'
                                  className='form-control mb-2'
                                  placeholder={t('Credit Card Description')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setCreditCardInfoEN(e.target.value)
                                  }}
                                  value={creditCardInfoEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            <button className='btn btn-success' onClick={toggleCustomDocs}>
                              {t('Add Custom Docs')}
                            </button>
                          </div>
                        </div>
                        {showCustomDocs && (
                          <>
                            {customDocs.map((field, index) => (
                              <div key={index} className='row'>
                                {primaryLanguage === 'English' && (
                                  <>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Document Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(e) =>
                                            handleChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.en_title}
                                        </div>
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 required form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='en_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.en_description}
                                          onChange={(e) =>
                                            handleChange(index, 'en_description', e.target.value)
                                          }
                                        ></textarea>
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.en_description}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description Info (Russian)')}
                                        </label>
                                        <textarea
                                          name='ru_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.ru_description}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description Info (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='uz_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.uz_description}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {primaryLanguage === 'Russian' && (
                                  <>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Document Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.ru_title}
                                        </div>
                                      </div>
                                      <div className='my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description Info (Russian)')}
                                        </label>
                                        <textarea
                                          name='ru_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.ru_description}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_description', e.target.value)
                                          }
                                        ></textarea>
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.ru_description}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(e) =>
                                            handleChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='en_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.en_description}
                                          onChange={(e) =>
                                            handleChange(index, 'en_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description Info (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='uz_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.uz_description}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {primaryLanguage === 'Uzbek' && (
                                  <>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Document Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.uz_title}
                                        </div>
                                      </div>
                                      <div className='my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description Info (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='uz_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.uz_description}
                                          onChange={(e) =>
                                            handleChange(index, 'uz_description', e.target.value)
                                          }
                                        ></textarea>
                                        <div className='text-danger fw-bold'>
                                          {errors[index]?.uz_description}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description Info (Russian)')}
                                        </label>
                                        <textarea
                                          name='ru_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.ru_description}
                                          onChange={(e) =>
                                            handleChange(index, 'ru_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Document Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(e) =>
                                            handleChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='en_description'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={field.en_description}
                                          onChange={(e) =>
                                            handleChange(index, 'en_description', e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                    </div>
                                  </>
                                )}
                                <div className='col-lg-12 d-flex justify-content-end align-items-end my-3'>
                                  {index !== 0 && (
                                    <button
                                      className='btn btn-danger mx-1'
                                      onClick={() => handleRemoveField(index)}
                                    >
                                      -
                                    </button>
                                  )}
                                  <button className='btn btn-success mx-1' onClick={handleAddField}>
                                    +
                                  </button>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button id="kt_ecommerce_add_product_submit"--> */}
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addDocumentRequiredApi}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddCarRentalDocuments}
